import { USER_ENDPOINTS } from './config';
import { apiFetch } from './client';

/**
 * GET /api/v1/users/me
 * Returns current user profile: firstName, lastName, userRoles, etc.
 */
export async function getCurrentUser() {
  const res = await apiFetch(USER_ENDPOINTS.me);
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.message || err.error || `Failed to fetch user (${res.status})`);
  }
  return res.json();
}
